import { type ComponentChildren } from 'preact';
import { useState } from 'preact/hooks';

export type EditorPane = 'materials' | 'canvas' | 'inspector';

export function EditorShell({
  labels,
  materials,
  canvas,
  inspector,
  defaultMobilePane = 'canvas',
  mobilePane: controlledMobilePane,
  onMobilePaneChange,
}: {
  labels: Record<EditorPane, string>;
  materials: ComponentChildren;
  canvas: ComponentChildren;
  inspector: ComponentChildren;
  defaultMobilePane?: EditorPane;
  mobilePane?: EditorPane;
  onMobilePaneChange?: (pane: EditorPane) => void;
}) {
  const [internalMobilePane, setInternalMobilePane] = useState<EditorPane>(defaultMobilePane);
  const mobilePane = controlledMobilePane ?? internalMobilePane;
  const setMobilePane = (pane: EditorPane) => { setInternalMobilePane(pane); onMobilePaneChange?.(pane); };
  const panes: Array<{ id: EditorPane; content: ComponentChildren }> = [
    { id: 'materials', content: materials },
    { id: 'canvas', content: canvas },
    { id: 'inspector', content: inspector },
  ];
  return <section className="product-editor">
    <nav className="product-editor-mobile-tabs" aria-label="Editor panels">
      {panes.map((pane) => <button type="button" key={pane.id} className={mobilePane === pane.id ? 'active' : ''} aria-pressed={mobilePane === pane.id} onClick={() => setMobilePane(pane.id)}>{labels[pane.id]}</button>)}
    </nav>
    <div className="product-editor-grid">
      {panes.map((pane) => <section key={pane.id} className={`product-editor-pane product-editor-${pane.id}${mobilePane === pane.id ? ' mobile-active' : ''}`} aria-label={labels[pane.id]}>{pane.content}</section>)}
    </div>
  </section>;
}
